module.exports = __webpack_public_path__ + "img/no_examplan.e341a661.png";